<template>
  <div class="clearfix">
    <a-upload
            action=""
            :multiple="multiple"
            :file-list="fileList"
            :accept="accept"
            :remove="onRemove"
            @change="onChange"
            :showUploadList="false"
            :before-upload="beforeUpload"
            :customRequest="uploadFile"
    >
      <a-button v-if="fileList.length < numberLimit">
        <a-icon type="plus" />
        选择文件
      </a-button>
    </a-upload>
    <a-progress :percent="progress" v-if="progress>0&&progress<100" />
<!--    <div>{{fileList}}</div>-->
    <div>
      <a-tag @click="download(file)"  :key="key" v-for="(file, key) in fileList" @close="(e) => handleClose(key,e)" :closable="true">
        <a-icon type="paper-clip" /> {{file.name}}
      </a-tag>

    </div>
  </div>
</template>
<script>
  import OSS from 'ali-oss';
  import setting from '@/config/setting'
  export default {
    name: 'FileUploader',
    data () {
      return {
        previewVisible: false,
        progress:0,
        previewImage: '',
        ossAccessTokenURL: 'https://api.ccachina.net/core/attachment/aliOssSts',
        ossFileURL: 'https://ccago.oss-cn-hangzhou.aliyuncs.com',
      }
    },
    props: {
      fileList: {
        type: Array,
        required: true,
      },
      numberLimit:{
        type: Number|String,
        default:100
      },
      multiple:{
        type: Boolean,
        default:false
      },
      accept:{
        type: String,
        default:'.jpg,.png,.mp4,.mov,.gif,.jpeg,.doc,.pdf,.ppt,.docx,.xls,.xlsx,.pptx,.rar,.zip,.mp3'
      }
    },
    mounted(){
    },

    methods: {
      onRemove(file){
        const that = this;
        this.fileList.forEach(function (element, index) {
          if (element.uid == file.uid) {
            that.fileList.splice(index, 1);
          }
        }, this);
      },
      beforeUpload(file){
        console.log('file');
        console.log(file);
      },
      uploadFile(evt){
        console.log('evt');
        console.log(evt);

        var that = this;
        console.log(that.ossFileURL);
        evt.onProgress({percent: 0});
        OSS.urllib.request(this.ossAccessTokenURL, {method: 'GET'}, function (err, response) {
          let result;
          if (err) {
            that.$message.error('上传异常:' + err);
            console && console.error(err);
            evt.onError(100);
            return;
          }
          try {
            result = JSON.parse(response);
          } catch (e) {
            return alert('parse sts response info error: ' + e.message);
          }
          var client = new OSS({
            accessKeyId: result.data.AccessKeyId,
            accessKeySecret: result.data.AccessKeySecret,
            stsToken: result.data.SecurityToken,
            endpoint: result.data.endpoint,
            bucket: result.data.bucket,
            secure: true
          });
          var suffix = evt.file.name.toLowerCase().split('.').splice(-1)[0];
          console.log(that.ossFileURL);
          var myDate = new Date();
          // todo  修改名称
          var file_save_name = 'uploader/000/user-xxx/' + evt.file.uid +'/' + evt.file.name +'.' + suffix;
          console.log(file_save_name);
          client.multipartUpload(file_save_name, evt.file,{
                progress: function (p, checkpoint) {
                  console.log('----上传进度----')
                  that.progress = parseInt(p * 100)
                  console.log(that.progress)
                  // console.log(p) 
                  evt.onProgress({
                    percent: that.progress,
                  });
                  that.$emit('uploadProgress', {
                    progress: parseInt(p * 100),
                    name: evt.file.name,
                  })
                  //                 console.log(p,checkpoint)
                },
              }).then(function (result) {
            evt.onSuccess();
            console.log(that.ossFileURL);
            var file = {
              uid: evt.file.uid,
              url: that.ossFileURL + '/' + file_save_name,
              name: evt.file.name,
              save_name: file_save_name
            }
            evt.onProgress({
              percent: 100,
            });
            that.fileList.push(file);
            that.$message.success(evt.file.name + '上传成功');

            that.$emit('change', that.fileList)
          }).catch(function (err) {
            evt.onError();
            that.$message.error(evt.file.name + '上传失败');
          });
        });
      },
      handleClose(index,e){
        e.stopPropagation();
        let that =this;
        that.fileList.splice(index,1);
      },
      onChange(){

      },
      download(file){
        let self = this;
        window.open(file.url);
      }
    },
  }
</script>
<style>
  /* you can make up upload button and sample style by using stylesheets */
  .ant-upload-select-picture-card i {
    font-size: 32px;
    color: #999;
  }

  .ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
  }
</style>
